import React from "react";
import Sparkler from "./Sparkler";

export default function GeneratingPlaceholder(){
	return (
		<div className="generating-status">
			<Sparkler />
			Generating Assets...
		</div>
	);
}

GeneratingPlaceholder.displayName = "GeneratingPlaceholder";
